import ScreenHeader from "@/components/ScreenHeader";
import "./style.css";
import { useTranslation } from "react-i18next";
import TextBox from "../../../shared/TextBox/TextBox";
import { Block } from "@/components/crRender";

const Complaint = ({ data }) => {
  const {t} = useTranslation();
  const { requestData } = data || {};

  return (
    <div className="bg-white complaint-container mt-4">
      <ScreenHeader title={t("intake-diagnosis-complaints")} icon="solar:danger-triangle-outline" className="bg-transparent mx-0 px-0 text-warning" />
     <Block isRender={requestData?.medicalDiagnosis}>
      <TextBox text={requestData?.medicalDiagnosis} className="complaint-text-box" />
     </Block>
     <Block isRender={!requestData?.medicalDiagnosis}>
      <div className="alert alert-info">{t("no-data")}</div>
     </Block>
    </div>
  );
};

export default Complaint;